import { jsxs as t, jsx as d } from "react/jsx-runtime";
import a from "clsx";
import { forwardRef as u } from "react";
const _ = (e) => a(e), o = "dds-required-field-key-v0142";
function $({ className: e = "", ...r }) {
  return /* @__PURE__ */ t("p", { className: `${o} ${e}`, ...r, children: [
    /* @__PURE__ */ d("span", { className: `${o}__required-indicator`, children: "*" }),
    "Required field"
  ] });
}
const s = "dds-form-v0162", v = u(
  ({ children: e, className: r, footerActions: i, noValidate: c = !0, requiredFieldKey: n = !1, ...f }, l) => {
    const m = _({
      [s]: !0,
      [r ?? ""]: ((r == null ? void 0 : r.length) ?? 0) > 0
    });
    return /* @__PURE__ */ t("form", { ref: l, className: m, noValidate: c, ...f, children: [
      n && /* @__PURE__ */ d($, { className: `${s}__required-field-key` }),
      e && /* @__PURE__ */ d("div", { className: `${s}__fields`, children: e }),
      i && /* @__PURE__ */ d("div", { className: `${s}__footer-actions`, children: i })
    ] });
  }
);
export {
  v as Form
};
//# sourceMappingURL=index.js.map
